<template>
    <div>
        <comp-featured/>
        <comp-content/>
    </div>
</template>

<script>
	/* eslint-disable */ 
import compFeatured from './featured';
import compContent from './content';
export default {
    components:{
        compFeatured,
        compContent
    },

    methods: {
	  toggleBodyClass(addRemoveClass, className) {
	    const el = document.body;

	    if (addRemoveClass === 'addClass') {
	      el.classList.add(className);
	    } else {
	      el.classList.remove(className);
	    }
	  },
	},
	mounted() {
	  this.toggleBodyClass('addClass', 'home');
	},
	destroyed() {
	  this.toggleBodyClass('removeClass', 'home');
	}
}
</script>